'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuBarDropdownItem = exports.MenuBarItem = exports.MenuBarDropdown = exports.InternalMenuBarDropdown = exports.MenuBar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ramda = require('ramda');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _visualStack = require('@cjdev/visual-stack');

var _actions = require('../actions.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuBar = exports.MenuBar = function (_Component) {
  _inherits(MenuBar, _Component);

  function MenuBar() {
    _classCallCheck(this, MenuBar);

    return _possibleConstructorReturn(this, (MenuBar.__proto__ || Object.getPrototypeOf(MenuBar)).apply(this, arguments));
  }

  _createClass(MenuBar, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        menuBarName: this.props.name
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          _name = _props.name,
          otherProps = _objectWithoutProperties(_props, ['children', 'name']);

      return _react2.default.createElement(
        _visualStack.MenuBar.MenuBar,
        otherProps,
        children
      );
    }
  }]);

  return MenuBar;
}(_react.Component);

MenuBar.propTypes = {
  name: _propTypes2.default.string.isRequired
};
MenuBar.childContextTypes = {
  menuBarName: _propTypes2.default.string
};

var InternalMenuBarDropdown = exports.InternalMenuBarDropdown = function (_Component2) {
  _inherits(InternalMenuBarDropdown, _Component2);

  function InternalMenuBarDropdown() {
    _classCallCheck(this, InternalMenuBarDropdown);

    var _this2 = _possibleConstructorReturn(this, (InternalMenuBarDropdown.__proto__ || Object.getPrototypeOf(InternalMenuBarDropdown)).call(this));

    _this2.handleClick = function (e) {
      var node = _reactDom2.default.findDOMNode(_this2);
      var menuBarName = _this2.context.menuBarName;
      var _this2$props = _this2.props,
          name = _this2$props.name,
          closeDropdown = _this2$props.closeDropdown,
          openDropdown = _this2$props.openDropdown;


      if (node.contains(e.target) && !_this2.isOpen()) {
        openDropdown(menuBarName, name);
      } else {
        // close dropdown if clicking outside
        closeDropdown(menuBarName, name);
      }
    };
    return _this2;
  }

  _createClass(InternalMenuBarDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClick, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClick, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var otherProps = (0, _ramda.omit)(['children', 'menuBars', 'name', 'closeDropdown', 'openDropdown'], this.props);
      return _react2.default.createElement(
        _visualStack.MenuBar.MenuBarDropdown,
        _extends({ open: this.isOpen() }, otherProps),
        children
      );
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      var _props2 = this.props,
          menuBars = _props2.menuBars,
          dropdownName = _props2.name;
      var menuBarName = this.context.menuBarName;

      var menuBarState = menuBars[menuBarName] || {};
      var dropdownState = menuBarState[dropdownName] || {};
      return !!dropdownState.open;
    }
  }]);

  return InternalMenuBarDropdown;
}(_react.Component);

InternalMenuBarDropdown.propTypes = {
  name: _propTypes2.default.string.isRequired
};
InternalMenuBarDropdown.contextTypes = {
  menuBarName: _propTypes2.default.string.isRequired
};
var MenuBarDropdown = exports.MenuBarDropdown = (0, _reactRedux.connect)(function (state) {
  return { menuBars: state.visualStack.menuBar };
}, { openDropdown: _actions.openDropdown, closeDropdown: _actions.closeDropdown })(InternalMenuBarDropdown);

var MenuBarItem = exports.MenuBarItem = _visualStack.MenuBar.MenuBarItem;
var MenuBarDropdownItem = exports.MenuBarDropdownItem = _visualStack.MenuBar.MenuBarDropdownItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack-redux/lib/components/MenuBar.js
// module id = 842
// module chunks = 0